var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTokenImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 636.43,
    height: 606.268,
    viewBox: "0 0 636.43 606.268",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_464",
    "data-name": "Caminho 464",
    d: "M184.825,263.18l631.1-3.274V862.9l-631.1,3.274Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_231",
    "data-name": "Ret\\xE2ngulo 231",
    width: 379.947,
    height: 39.601,
    transform: "translate(217.229 481.653)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_232",
    "data-name": "Ret\\xE2ngulo 232",
    width: 35.947,
    height: 5.938,
    transform: "translate(506.688 604.031)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_233",
    "data-name": "Ret\\xE2ngulo 233",
    width: 41.895,
    height: 8.174,
    transform: "translate(438.53 520.28)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_234",
    "data-name": "Ret\\xE2ngulo 234",
    width: 41.895,
    height: 8.174,
    transform: "translate(438.53 536.969)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_235",
    "data-name": "Ret\\xE2ngulo 235",
    width: 41.895,
    height: 9.039,
    transform: "translate(438.53 556.901)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_236",
    "data-name": "Ret\\xE2ngulo 236",
    width: 4.094,
    height: 4.048,
    transform: "translate(657.119 833.976)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_237",
    "data-name": "Ret\\xE2ngulo 237",
    width: 51.359,
    height: 13.731,
    transform: "translate(619.722 845.22)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_238",
    "data-name": "Ret\\xE2ngulo 238",
    width: 4.096,
    height: 4.047,
    transform: "translate(597.736 840.68)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_239",
    "data-name": "Ret\\xE2ngulo 239",
    width: 51.235,
    height: 14.398,
    transform: "translate(560.643 851.777)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_240",
    "data-name": "Ret\\xE2ngulo 240",
    width: 59.321,
    height: 101.145,
    transform: "translate(671.632 593.999)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_194",
    "data-name": "Grupo 194",
    transform: "translate(-184.825 -259.905)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_230",
    "data-name": "Ret\\xE2ngulo 230",
    width: 636.43,
    height: 602.994,
    transform: "translate(184.825 263.18)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_104",
    "data-name": "Grupo 104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_103",
    "data-name": "Grupo 103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_193",
    "data-name": "Grupo 193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_192",
    "data-name": "Grupo 192",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_102",
    "data-name": "Grupo 102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_151",
    "data-name": "Caminho 151",
    d: "M691.556,488.342l.2,67.391-28.91,1.379-.836-16.391s-10.269,2.039-12.918-7.5c-1.693-6.092-1.271-53.175-1.271-53.175Z",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_152",
    "data-name": "Caminho 152",
    d: "M692.061,541.121c3.078-3.2,4.5-7.648,5.217-12.029s.84-8.853,1.8-13.191c1.01-4.551,2.931-8.862,3.91-13.42s.888-9.661-1.812-13.461c0,0-1.782-5.221-9.418-5.644,0,0-6.485-10.5-16.063-9.581-13.024,1.246-13.379-2.585-22.35-4-8.386-1.319-9.944,6.156-9.944,6.156s-4.611,3.424-4.824,8.354a1.155,1.155,0,0,1-.005.132,11.366,11.366,0,0,0,7.771,11.11q.867.293,1.741.572a11.03,11.03,0,0,1,4.57,2.3c1.814,1.807,2.111,4.617,2.017,7.18s-.457,5.205.408,7.613c.294.822,1,1.723,1.843,1.5,1.005-.268.96-1.668,1.059-2.7.286-3.017,4.163-5.308,6.889-3.1a4.615,4.615,0,0,1,1.385,5.612c-1.013,2.123-3.223,3.783-3.652,6.135-.722,3.963,3.928,7.428,5.7,9.583a16.014,16.014,0,0,0,2.028,2.129c3.836,3.229,7.6,7.694,12.641,9.443,3.383,1.171,7.5.879,10.073-1.617",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_156",
    "data-name": "Caminho 156",
    d: "M660.912,553.854s-.788-7.16.246-8.389,32.13-1.024,32.13-1.024l1.637,8.211-3.461,6.139-29.581,2.572Z",
    fill: "#0b3d20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_23",
    "data-name": "Caminho 23",
    d: "M419.115,844.341c-1.962-1.682-6.337-7.011-2.968-13.211,1.237-2.271,3.865-3.4,6.242-4.4s4.878-1.869,6.845-3.545c3.711-3.157,4.734-8.4,7.2-12.614,2.829-4.836,8.107-8.456,13.684-8.2,6.385.291,11.71,5.507,14.125,11.453s2.5,12.551,2.549,18.972c.026,3.551-.131,7.555-2.737,9.953-2.4,2.21-6.024,2.238-9.28,2.138l-34.9-1.073",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_24",
    "data-name": "Caminho 24",
    d: "M485.863,748.374H394.085l16.532,98.579a11.01,11.01,0,0,0,7.837,8.777c.109.034.219.057.321.087.274.07.537.162.817.211a11.52,11.52,0,0,0,1.869.219c.006.03.01.064.015.095l.448-.071H462.83a11.536,11.536,0,0,0,2.247-.22,11.052,11.052,0,0,0,9.286-9.635l7.968-67.922.361-2.7h-.042l3.155-26.9ZM468.55,811.256h-9.419l.949-28.61h10.914Zm3.358-28.61h9.014l-3.357,28.61H469.46ZM445,842.971l-.573-24.854h13.563l-.825,24.854Zm-14.665-24.858h13.179l.573,24.854h-11.82Zm1.018,24.854H420.3c-1.05-6.706-2.419-15.433-3.9-24.854h13.014ZM429.8,811.252l-2.224-28.61H442.7l.66,28.61Zm14.465,0-.66-28.61H459.17l-.95,28.61Zm-.817-35.472-.611-26.491h17.436L459.4,775.78Zm-.912,0H427.046l-2.059-26.491h16.944Zm-16.407,0H409.74c-.579-3.659-1.131-7.124-1.628-10.239-1.71-10.711-2.353-14.74-2.71-16.255h18.672Zm.533,6.861,2.224,28.609H415.333c-.456-2.9-.918-5.839-1.381-8.779-1.063-6.753-2.127-13.505-3.126-19.831ZM414.409,811.25h-8.856l-4.8-28.609H409.9c1.4,8.842,2.947,18.687,4.506,28.609m1.077,6.861c1.351,8.6,2.679,17.081,3.9,24.853h-8.51L406.7,818.113Zm42.589,24.853.825-24.853h9.065l-2.124,24.853Zm2.231-67.185.879-26.491h12.653l-2.263,26.491ZM404.538,749.29c.363,1.916,2.039,12.341,4.287,26.491h-9.212L395.17,749.29Zm69.312,93.681h-7.1l2.124-24.854h7.879Zm7.883-67.185H472.5l2.263-26.492h10.081Z",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_76",
    "data-name": "Ret\\xE2ngulo 76",
    width: 142.521,
    height: 96.065,
    transform: "translate(582.63 328.17) rotate(-9.613)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_25",
    "data-name": "Caminho 25",
    d: "M723.142,304.362a10.057,10.057,0,0,1-1.1,1.481l-3.331,4.092-12.441,14.9-41.528,48.975-.342.4-.465-.257-1.12-.621-56.83-31.7-17.148-9.736-4.632-2.7a10.1,10.1,0,0,1-1.572-1.02,10.117,10.117,0,0,1,1.7.792l4.749,2.492,17.35,9.378c14.7,8.087,36.885,19.148,59.1,31.373l-.962.621-.8.146,41.821-48.723,12.751-14.638q2.19-2.451,3.518-3.933a10.053,10.053,0,0,1,1.291-1.319",
    fill: "#edefe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_26",
    "data-name": "Caminho 26",
    d: "M598.678,422.881c-.308-.182,8.059-14.95,18.687-32.993,12.063-20.478,23.612-30.084,19.8-32.338.307.181-8.057,14.95-18.686,33s-19.492,32.516-19.8,32.335",
    fill: "#edefe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27",
    "data-name": "Caminho 27",
    d: "M683.671,348.452c.241-.265,12.861,10.855,28.2,24.831s27.566,25.526,27.325,25.791-10.779-10.852-26.115-24.834-29.646-25.522-29.4-25.787",
    fill: "#edefe6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_77",
    "data-name": "Ret\\xE2ngulo 77",
    width: 71.587,
    height: 48.253,
    transform: "translate(224.084 564.277) rotate(-5.077)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_28",
    "data-name": "Caminho 28",
    d: "M295.39,557.942a4.921,4.921,0,0,1-.607.7l-1.831,1.917c-1.661,1.7-3.978,4.062-6.824,6.968L263.386,590.4l-.187.189-.22-.147-.536-.355-27.2-18.138-8.2-5.557-2.21-1.539a5.189,5.189,0,0,1-.747-.573,5.2,5.2,0,0,1,.819.465l2.279,1.437,8.315,5.386,27.3,17.978.537.355-.408.042c8.928-8.873,16.99-16.883,22.878-22.736,2.908-2.843,5.277-5.166,6.97-6.822.8-.761,1.429-1.369,1.915-1.831a5.118,5.118,0,0,1,.7-.607",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_29",
    "data-name": "Caminho 29",
    d: "M228.355,612.34c-.147-.1,4.63-7.166,10.662-15.777s11.055-15.508,11.2-15.4-4.63,7.168-10.67,15.777S228.5,612.441,228.355,612.34",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_30",
    "data-name": "Caminho 30",
    d: "M273.872,578.451c.13-.122,6.01,5.948,13.13,13.555s12.788,13.877,12.658,14-6.01-5.946-13.133-13.557-12.787-13.876-12.657-14",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_31",
    "data-name": "Caminho 31",
    d: "M801.988,506.111s.048-.38.162-1.082q.184-1.092.523-3.1c.472-2.727,1.158-6.688,2.033-11.745,1.781-10.132,4.332-24.65,7.438-42.315l.229.33-84.719-15.125h-.006l.41-.284c-3.738,20.77-7.286,40.5-10.467,58.18l-.261-.375L778.3,501.7l17.426,3.213,4.641.873,1.2.235a4.006,4.006,0,0,1,.418.1,2.793,2.793,0,0,1-.387-.051l-1.174-.19-4.593-.785c-4.061-.707-9.948-1.733-17.383-3.03l-61.234-10.82-.318-.056.059-.32c3.162-17.68,6.691-37.417,10.406-58.191l.062-.347.349.061h.006l84.694,15.26.281.05-.051.28c-3.239,17.715-5.9,32.275-7.762,42.436-.933,5.019-1.662,8.949-2.164,11.652q-.373,1.964-.577,3.033c-.132.679-.212,1.012-.212,1.012",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32",
    "data-name": "Caminho 32",
    d: "M812.426,447.928a7.511,7.511,0,0,1-.964.7l-2.842,1.888L798.1,457.35l-34.846,22.327c-.948-.167-.27-.057-.486-.1l-.015-.019-.029-.038-.056-.076-.11-.151-.227-.3-.456-.6-.907-1.2-1.794-2.37-3.508-4.636c-2.294-3.039-4.507-5.973-6.62-8.769l-11.177-14.873-7.486-10.066q-1.265-1.736-2.007-2.757a7.368,7.368,0,0,1-.66-.989,7.637,7.637,0,0,1,.77.9q.783.988,2.112,2.676l7.666,9.93c3.229,4.224,7.055,9.233,11.3,14.782l6.654,8.745q1.727,2.277,3.517,4.629l1.8,2.368.907,1.2.456.6.229.3.11.151.056.075.03.037.014.02c-.205-.035.481.1-.457-.071l34.956-22.152,10.638-6.646,2.912-1.777a7.5,7.5,0,0,1,1.041-.578",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_33",
    "data-name": "Caminho 33",
    d: "M751.256,463.8c.122.152-7.425,6.4-16.853,13.943s-17.176,13.545-17.3,13.392,7.424-6.393,16.856-13.944,17.172-13.542,17.295-13.391",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_34",
    "data-name": "Caminho 34",
    d: "M802.412,506.886c-.171.1-5.08-8.564-10.962-19.333s-10.513-19.581-10.341-19.676,5.077,8.562,10.961,19.335,10.514,19.58,10.342,19.676",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_35",
    "data-name": "Caminho 35",
    d: "M426,615.755v16.352H355.676a8.177,8.177,0,0,1,0-16.354",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_36",
    "data-name": "Caminho 36",
    d: "M426,628.681H402.7a4.609,4.609,0,0,1-4.609-4.609v-.28a4.609,4.609,0,0,1,4.609-4.609H426Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_37",
    "data-name": "Caminho 37",
    d: "M426,599.4v16.357H355.676a8.178,8.178,0,0,1,0-16.357Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_38",
    "data-name": "Caminho 38",
    d: "M426,612.328H402.7a4.61,4.61,0,0,1-4.609-4.609v-.281a4.61,4.61,0,0,1,4.609-4.609H426Z",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_39",
    "data-name": "Caminho 39",
    d: "M375.213,573.164,364.044,599.4h7.189l4.962-14.012Z",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_40",
    "data-name": "Caminho 40",
    d: "M409.51,549.424l4.315,49.976H377.319l-4.01-49.976Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_41",
    "data-name": "Caminho 41",
    d: "M405.944,553.388l3.782,41.86-27.4.361-3.706-42.464Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_42",
    "data-name": "Caminho 42",
    d: "M400.13,559.183l2.151,28.8h-14.62l-2.579-28.8Z",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43",
    "data-name": "Caminho 43",
    d: "M821.255,856.339c0,.2-142.481.366-318.2.366-175.779,0-318.228-.163-318.228-.366s142.451-.366,318.228-.366c175.718,0,318.2.162,318.2.366",
    fill: "#edefe6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_78",
    "data-name": "Ret\\xE2ngulo 78",
    width: 379.658,
    height: 257.546,
    transform: "translate(215.923 263.515)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_44",
    "data-name": "Caminho 44",
    d: "M597.321,521.254H217.085V263.322H597.321Zm-.291-257.739H217.372v257.55H597.03",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_45",
    "data-name": "Caminho 45",
    d: "M597.321,521.254H217.085V263.322H597.321Zm-.291-257.739H217.372v257.55H597.03",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_79",
    "data-name": "Ret\\xE2ngulo 79",
    width: 379.947,
    height: 25.532,
    transform: "translate(217.229 263.467)",
    fill: "#0c4727"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_74",
    "data-name": "Grupo 74"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_73",
    "data-name": "Grupo 73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_173",
    "data-name": "Grupo 173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_172",
    "data-name": "Grupo 172",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_72",
    "data-name": "Grupo 72"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_80",
    "data-name": "Ret\\xE2ngulo 80",
    width: 379.947,
    height: 39.601,
    transform: "translate(217.229 481.653)",
    fill: "#ebebeb"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_46",
    "data-name": "Caminho 46",
    d: "M289.347,500.817h3.137l.989,2.055h.674l-3.14-6.556h-.172l-3.147,6.556h.681Zm1.571-3.268,1.27,2.657h-2.547Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_82",
    "data-name": "Ret\\xE2ngulo 82",
    width: 7.428,
    height: 0.523,
    transform: "translate(287.18 504.269)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_47",
    "data-name": "Caminho 47",
    d: "M243.185,495.954h-.5a2.764,2.764,0,0,0-2.609,2.817,11.7,11.7,0,0,0,2.609,5.587s.2.343.5,0a11.7,11.7,0,0,0,2.61-5.587,2.764,2.764,0,0,0-2.61-2.817m-.25,4.459a1.539,1.539,0,1,1,1.539-1.539h0a1.539,1.539,0,0,1-1.539,1.539",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_48",
    "data-name": "Caminho 48",
    d: "M277.971,502.5a1.591,1.591,0,0,1-3.18,0v-5.136a1.029,1.029,0,1,1,2.057,0h0v4.356h.006a.585.585,0,0,1-1.143-.009v-3.354h-.385v3.363h.012a.95.95,0,0,0,1.883,0h.009v-.086c0-.024,0-.046,0-.071h0v-4.247h0a1.413,1.413,0,0,0-2.823,0h0v5.366h.01a1.972,1.972,0,0,0,3.927,0h.009v-4.324h-.382Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_49",
    "data-name": "Caminho 49",
    d: "M261.062,498.612l-1.472-2.979-1.47,2.979-3.289.478,2.379,2.321-.562,3.277,2.942-1.548,2.943,1.547-.563-3.277,2.381-2.321Zm.833,5.2-2.308-1.209-2.308,1.209.42-2.442.024-.125-1.869-1.818,2.58-.375,1.15-2.336,1.155,2.336,2.574.375-1.766,1.733-.089.087Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_50",
    "data-name": "Caminho 50",
    d: "M318.972,491.973h-.478v15.265h.478Zm-.235,15.264",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_83",
    "data-name": "Ret\\xE2ngulo 83",
    width: 6.077,
    height: 6.477,
    transform: "translate(303.553 497.375)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_51",
    "data-name": "Caminho 51",
    d: "M305.473,495.859v.5h2.24v-.5h1.918v1h-6.078v-1Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_84",
    "data-name": "Ret\\xE2ngulo 84",
    width: 2.239,
    height: 0.498,
    transform: "translate(305.473 495.361)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_85",
    "data-name": "Ret\\xE2ngulo 85",
    width: 2.239,
    height: 0.498,
    transform: "translate(305.473 495.859)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_52",
    "data-name": "Caminho 52",
    d: "M332.731,500.844l1.869-1.869.226.226-2.088,2.089-2.089-2.089.227-.226Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_53",
    "data-name": "Caminho 53",
    d: "M561.741,276.512h5.267v-.28h0v-.278h-5.267Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_54",
    "data-name": "Caminho 54",
    d: "M588.013,273.8l-.4-.395-2.436,2.438-2.436-2.437-.394.395,2.436,2.436-2.436,2.437.394.4,2.436-2.437,2.436,2.437.4-.4-2.434-2.438Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_55",
    "data-name": "Caminho 55",
    d: "M571.733,279.146h5.826v-5.832h-5.826Zm.56-5.267H577v4.711h-4.709Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_56",
    "data-name": "Caminho 56",
    d: "M588.587,347.248a2.068,2.068,0,0,0-2-2.064h-7.851v.013a2.887,2.887,0,0,0,0,5.749v.014h6.327V350.4H579a2.326,2.326,0,0,1-.1-4.651h7.62a1.506,1.506,0,1,1,0,3.012h-6.376v.006a.854.854,0,0,1,.011-1.678h4.909v-.562h-4.92v.022a1.389,1.389,0,0,0,0,2.748v.013h.127c.035,0,.069.011.1.011v-.011h6.214a2.07,2.07,0,0,0,2-2.064",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_57",
    "data-name": "Caminho 57",
    d: "M234.508,271.9v6.99h-.819l-4.195-5.213v5.213h-1V271.9h.818l4.194,5.212V271.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_58",
    "data-name": "Caminho 58",
    d: "M241.219,276.559h-4.294a1.793,1.793,0,0,0,1.917,1.547,1.975,1.975,0,0,0,1.528-.638l.529.619a2.885,2.885,0,0,1-4.932-1.848,2.59,2.59,0,0,1,2.483-2.694c.058,0,.116,0,.174,0a2.552,2.552,0,0,1,2.62,2.481c0,.082,0,.164-.005.246s-.01.2-.02.288m-4.294-.689h3.4a1.708,1.708,0,0,0-3.4,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_59",
    "data-name": "Caminho 59",
    d: "M250.469,273.594l-1.979,5.293h-.919l-1.525-4.015-1.548,4.016h-.918l-1.969-5.294h.909l1.539,4.216,1.6-4.216h.809l1.568,4.234,1.578-4.234Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_60",
    "data-name": "Caminho 60",
    d: "M259.324,278.018v.869h-5.073V271.9h4.933v.869h-3.933v2.146h3.5v.849h-3.5v2.257Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_61",
    "data-name": "Caminho 61",
    d: "M269.582,275.841v3.046h-.961v-2.936c0-1.039-.5-1.548-1.368-1.548a1.539,1.539,0,0,0-1.6,1.473,1.522,1.522,0,0,0,.015.286v2.726h-.959v-2.937c0-1.039-.5-1.548-1.369-1.548a1.538,1.538,0,0,0-1.6,1.473,1.608,1.608,0,0,0,.014.286v2.726h-.958v-5.294h.919v.789a2.144,2.144,0,0,1,1.827-.838,1.958,1.958,0,0,1,1.838.978,2.382,2.382,0,0,1,2.035-.978,2.028,2.028,0,0,1,2.18,1.866,2,2,0,0,1-.012.43",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_62",
    "data-name": "Caminho 62",
    d: "M275.532,275.691v3.195h-.907v-.7a1.968,1.968,0,0,1-1.738.758c-1.2,0-1.957-.638-1.957-1.557,0-.849.55-1.548,2.127-1.548h1.52v-.189c0-.809-.468-1.28-1.417-1.28a2.682,2.682,0,0,0-1.677.571l-.4-.719a3.518,3.518,0,0,1,2.187-.679c1.448,0,2.266.7,2.266,2.147m-.959,1.577v-.739H273.1c-.948,0-1.216.368-1.216.819,0,.529.439.858,1.168.858a1.538,1.538,0,0,0,1.527-.938",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_63",
    "data-name": "Caminho 63",
    d: "M277.133,271.956a.632.632,0,0,1,.634-.628h.015a.619.619,0,0,1,.647.591v.017a.65.65,0,0,1-1.3.02m.17,1.638h.959v5.293H277.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_86",
    "data-name": "Ret\\xE2ngulo 86",
    width: 0.959,
    height: 7.41,
    transform: "translate(280.086 271.478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_64",
    "data-name": "Caminho 64",
    d: "M228.9,297.7h-2.4v-.868h5.781v.868h-2.4v6.122H228.9Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_65",
    "data-name": "Caminho 65",
    d: "M232.19,301.177a2.748,2.748,0,1,1,2.787,2.708h-.031a2.633,2.633,0,0,1-2.754-2.506c0-.067,0-.134,0-.2m4.533,0a1.784,1.784,0,1,0-1.777,1.869,1.737,1.737,0,0,0,1.781-1.691,1.519,1.519,0,0,0,0-.178",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_66",
    "data-name": "Caminho 66",
    d: "M241.247,299.159a.667.667,0,0,1,.656-.678h.024a.66.66,0,0,1,.66.659c0,.006,0,.013,0,.019a.666.666,0,0,1-.642.689h-.017a.676.676,0,0,1-.68-.673v-.016m0,4.035a.669.669,0,0,1,.658-.679h.022a.66.66,0,0,1,.66.659v.02a.66.66,0,0,1-.63.688h-.029a.675.675,0,0,1-.68-.67v-.018",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_67",
    "data-name": "Caminho 67",
    d: "M227.927,323.841a3.536,3.536,0,0,1,3.491-3.579c.073,0,.145,0,.218,0a3.454,3.454,0,0,1,2.655,1.089l-.648.628a2.593,2.593,0,0,0-1.968-.829,2.688,2.688,0,0,0-.153,5.374h.153a2.6,2.6,0,0,0,1.968-.84l.648.631a3.468,3.468,0,0,1-2.666,1.1,3.533,3.533,0,0,1-3.691-3.367c0-.07-.005-.139,0-.208",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_68",
    "data-name": "Caminho 68",
    d: "M234.861,324.69a2.638,2.638,0,0,1,2.574-2.7c.075,0,.151,0,.226,0a2.361,2.361,0,0,1,2.155,1.129l-.729.471a1.648,1.648,0,0,0-1.436-.76,1.863,1.863,0,0,0,0,3.725,1.648,1.648,0,0,0,1.436-.758l.729.458a2.368,2.368,0,0,1-2.155,1.138,2.652,2.652,0,0,1-2.793-2.5c0-.068,0-.136,0-.2",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_69",
    "data-name": "Caminho 69",
    d: "M243.278,322.673a.667.667,0,0,1,.656-.679h.023a.66.66,0,0,1,.66.66v.019a.666.666,0,0,1-.643.688h-.017a.676.676,0,0,1-.679-.673v-.016m0,4.035a.669.669,0,0,1,.657-.68h.022a.66.66,0,0,1,.66.66v.02a.66.66,0,0,1-.631.687h-.029a.675.675,0,0,1-.679-.67v-.018",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_70",
    "data-name": "Caminho 70",
    d: "M226.874,350.357l.368-.78a3.593,3.593,0,0,0,2.309.809c1.209,0,1.727-.468,1.727-1.078,0-1.707-4.233-.629-4.233-3.225,0-1.078.838-2,2.676-2a4.119,4.119,0,0,1,2.248.618l-.33.8a3.609,3.609,0,0,0-1.917-.568c-1.188,0-1.7.5-1.7,1.108,0,1.708,4.233.641,4.233,3.207,0,1.068-.859,1.987-2.706,1.987a4.147,4.147,0,0,1-2.676-.879",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_71",
    "data-name": "Caminho 71",
    d: "M238.5,345.863v5.293h-.913v-.8a2.148,2.148,0,0,1-1.8.858,2.078,2.078,0,0,1-2.279-1.857,2.125,2.125,0,0,1,0-.451v-3.044h.959V348.8c0,1.039.518,1.558,1.429,1.558a1.561,1.561,0,0,0,1.638-1.759v-2.735Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_72",
    "data-name": "Caminho 72",
    d: "M245.8,348.51a2.578,2.578,0,0,1-2.442,2.7c-.078,0-.156,0-.234,0a2.233,2.233,0,0,1-1.887-.9v.839h-.919v-7.409h.954v2.916a2.252,2.252,0,0,1,1.848-.849,2.569,2.569,0,0,1,2.676,2.456c0,.08,0,.16,0,.24m-.968,0a1.784,1.784,0,1,0-1.788,1.869,1.745,1.745,0,0,0,1.792-1.7c0-.058,0-.116,0-.174",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_73",
    "data-name": "Caminho 73",
    d: "M245.3,352.833l.31-.738a1.2,1.2,0,0,0,.778.25c.509,0,.789-.321.789-.929v-5.555h.959v5.532a1.579,1.579,0,0,1-1.383,1.753,1.546,1.546,0,0,1-.3.006,1.882,1.882,0,0,1-1.149-.32M247,344.225a.632.632,0,0,1,.635-.629h.014a.624.624,0,1,1-.649.629",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_74",
    "data-name": "Caminho 74",
    d: "M254.719,348.828h-4.3a1.792,1.792,0,0,0,1.917,1.547,1.979,1.979,0,0,0,1.528-.638l.528.619a2.885,2.885,0,0,1-4.932-1.848,2.591,2.591,0,0,1,2.484-2.694c.057,0,.114,0,.172,0a2.552,2.552,0,0,1,2.621,2.48c0,.082,0,.164-.005.247s-.01.2-.02.288m-4.293-.687h3.4a1.708,1.708,0,0,0-3.4,0",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_75",
    "data-name": "Caminho 75",
    d: "M255.572,348.509a2.644,2.644,0,0,1,2.588-2.7c.069,0,.139,0,.208,0a2.364,2.364,0,0,1,2.158,1.129l-.73.471a1.649,1.649,0,0,0-1.437-.76,1.869,1.869,0,0,0,0,3.726,1.649,1.649,0,0,0,1.437-.759l.73.458a2.368,2.368,0,0,1-2.158,1.139,2.652,2.652,0,0,1-2.793-2.5c0-.067,0-.135,0-.2",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_76",
    "data-name": "Caminho 76",
    d: "M264.8,350.847a1.811,1.811,0,0,1-1.159.368,1.508,1.508,0,0,1-1.675-1.322,1.493,1.493,0,0,1,0-.334v-2.906h-.9v-.789h.9v-1.158h.958v1.158h1.518v.789h-1.518v2.866a.781.781,0,0,0,.829.889,1.207,1.207,0,0,0,.749-.25Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_77",
    "data-name": "Caminho 77",
    d: "M268.19,346.492a.666.666,0,0,1,.656-.678.088.088,0,0,1,.023,0,.659.659,0,0,1,.66.659.131.131,0,0,1,0,.019.666.666,0,0,1-.642.689h-.017a.677.677,0,0,1-.68-.673c0-.005,0-.011,0-.016m0,4.035a.667.667,0,0,1,.657-.679h.022a.66.66,0,0,1,.66.659v.02a.66.66,0,0,1-.63.688h-.029a.675.675,0,0,1-.68-.67.154.154,0,0,1,0-.022",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_78",
    "data-name": "Caminho 78",
    d: "M355.819,302.569c0,.2-22.411.366-50.048.366s-50.052-.164-50.052-.366,22.4-.366,50.052-.366,50.048.163,50.048.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_79",
    "data-name": "Caminho 79",
    d: "M400.516,325.407c0,.2-32.417.366-72.395.366s-72.4-.163-72.4-.366,32.41-.366,72.4-.366,72.395.164,72.395.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_80",
    "data-name": "Caminho 80",
    d: "M346.974,348.069a2.257,2.257,0,0,1-.66.074l-1.9.069-7,.117c-5.914.066-14.083.11-23.107.11s-17.2-.041-23.111-.11l-7-.117-1.9-.069a2.257,2.257,0,0,1-.66-.074,2.223,2.223,0,0,1,.66-.073l1.9-.07,7-.116c5.914-.066,14.084-.11,23.111-.11s17.193.04,23.107.11l7,.116,1.9.07a2.257,2.257,0,0,1,.66.073",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81",
    "data-name": "Caminho 81",
    d: "M593.076,360.4c0,.2-84.109.366-187.842.366-103.767,0-187.859-.164-187.859-.366s84.092-.366,187.859-.366c103.731,0,187.842.164,187.842.366",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82",
    "data-name": "Caminho 82",
    d: "M593.076,335.678c0,.2-84.142.366-187.913.366-103.808,0-187.934-.162-187.934-.366s84.127-.365,187.934-.365c103.767,0,187.913.163,187.913.365",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_83",
    "data-name": "Caminho 83",
    d: "M593.076,313.989c0,.2-84.109.366-187.842.366-103.767,0-187.859-.164-187.859-.366s84.092-.366,187.859-.366c103.731,0,187.842.163,187.842.366",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_84",
    "data-name": "Caminho 84",
    d: "M263.931,390.55c0,.2-5.341.366-11.928.366s-11.928-.164-11.928-.366,5.339-.366,11.928-.366,11.928.164,11.928.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85",
    "data-name": "Caminho 85",
    d: "M342.394,408.415c0,.2-22.9.366-51.157.366s-51.161-.164-51.161-.366,22.9-.366,51.161-.366,51.157.164,51.157.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_86",
    "data-name": "Caminho 86",
    d: "M217.373,263.51c2.99,0,155.9-.132,379.659-.33h.329v.33c.01,78.386.02,165.685.031,257.515v.4h-.366c-142.892-.026-274.782-.05-379.658-.071h-.295v-.29c.179-156.808.291-255.141.295-257.55,0,2.4.11,100.738.294,257.55l-.294-.295c104.877-.02,236.766-.045,379.658-.07l-.367.365v-.031c.011-91.83.022-179.128.031-257.515l.336.336c-223.75-.2-376.669-.332-379.653-.34",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_87",
    "data-name": "Caminho 87",
    d: "M610.775,604.031h-170.4a13.289,13.289,0,0,1-13.287-13.287V475.669a6.026,6.026,0,0,1,6.026-6.026H618.036a6.026,6.026,0,0,1,6.026,6.026V590.744a13.289,13.289,0,0,1-13.287,13.287",
    fill: "#0c4727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_89",
    "data-name": "Caminho 89",
    d: "M542.635,604.031H508.423s-10.527,17.552,0,28.08h35.384s-17.442-11.421-1.173-28.08",
    fill: "#0c4727"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_77",
    "data-name": "Grupo 77",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_76",
    "data-name": "Grupo 76"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_175",
    "data-name": "Grupo 175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_174",
    "data-name": "Grupo 174",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_75",
    "data-name": "Grupo 75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_90",
    "data-name": "Caminho 90",
    d: "M508.422,604.031l-1.733,3.48,31.354,2.457a73.836,73.836,0,0,1,4.591-5.936Z"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_91",
    "data-name": "Caminho 91",
    d: "M533.638,590.991a3.878,3.878,0,1,1-3.88-3.877h0a3.878,3.878,0,0,1,3.877,3.877",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_88",
    "data-name": "Ret\\xE2ngulo 88",
    width: 178.085,
    height: 102.492,
    transform: "translate(436.533 477.046)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_89",
    "data-name": "Ret\\xE2ngulo 89",
    width: 41.913,
    height: 91.308,
    transform: "translate(438.529 485.723)",
    fill: "#0c4727"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_80",
    "data-name": "Grupo 80",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_79",
    "data-name": "Grupo 79"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_177",
    "data-name": "Grupo 177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_176",
    "data-name": "Grupo 176",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_78",
    "data-name": "Grupo 78"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_90",
    "data-name": "Ret\\xE2ngulo 90",
    width: 41.895,
    height: 8.173,
    transform: "translate(438.53 520.281)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_83",
    "data-name": "Grupo 83",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_82",
    "data-name": "Grupo 82"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_179",
    "data-name": "Grupo 179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_178",
    "data-name": "Grupo 178",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_81",
    "data-name": "Grupo 81"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_92",
    "data-name": "Ret\\xE2ngulo 92",
    width: 41.895,
    height: 8.173,
    transform: "translate(438.53 536.97)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_86",
    "data-name": "Grupo 86",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_85",
    "data-name": "Grupo 85"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_181",
    "data-name": "Grupo 181"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_180",
    "data-name": "Grupo 180",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_84",
    "data-name": "Grupo 84"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_94",
    "data-name": "Ret\\xE2ngulo 94",
    width: 41.895,
    height: 9.039,
    transform: "translate(438.53 556.901)"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_93",
    "data-name": "Caminho 93",
    d: "M473.154,532.741c0,.2-6.034.366-13.476.366s-13.477-.163-13.477-.366,6.034-.366,13.477-.366,13.476.164,13.476.366",
    fill: "#edefe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_94",
    "data-name": "Caminho 94",
    d: "M473.154,524.211c0,.205-6.034.367-13.476.367s-13.477-.163-13.477-.367,6.034-.366,13.477-.366,13.476.164,13.476.366",
    fill: "#edefe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_95",
    "data-name": "Caminho 95",
    d: "M480.441,565.94c0,.2-9.3.366-20.764.366s-20.766-.162-20.766-.366,9.295-.366,20.766-.366,20.764.163,20.764.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_96",
    "data-name": "Caminho 96",
    d: "M466.771,541.355c0,.2-4.6.366-10.284.366s-10.284-.164-10.284-.366,4.6-.366,10.284-.366,10.284.164,10.284.366",
    fill: "#edefe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_97",
    "data-name": "Caminho 97",
    d: "M469.677,560.44c0,.2-4.605.367-10.285.367s-10.284-.164-10.284-.367,4.6-.365,10.284-.365,10.285.162,10.285.365",
    fill: "#edefe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_98",
    "data-name": "Caminho 98",
    d: "M473.154,550.794c0,.2-6.034.366-13.476.366S446.2,551,446.2,550.794s6.034-.366,13.477-.366,13.476.164,13.476.366",
    fill: "#edefe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_99",
    "data-name": "Caminho 99",
    d: "M473.154,571.288c0,.2-6.034.366-13.476.366s-13.477-.164-13.477-.366,6.034-.366,13.477-.366,13.476.164,13.476.366",
    fill: "#edefe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_100",
    "data-name": "Caminho 100",
    d: "M458.917,491.882a9.976,9.976,0,0,0-4.506,18.882V507.7a4.7,4.7,0,0,1,9.4,0v2.846a9.979,9.979,0,0,0-4.9-18.674m.2,10.412a3.518,3.518,0,1,1,3.517-3.517h0a3.517,3.517,0,0,1-3.517,3.517",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_101",
    "data-name": "Caminho 101",
    d: "M459.115,503.009a4.7,4.7,0,0,0-4.7,4.7h0v3.053a9.923,9.923,0,0,0,9.4-.208V507.71a4.7,4.7,0,0,0-4.7-4.7h0",
    fill: "#dcccc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_102",
    "data-name": "Caminho 102",
    d: "M459.116,495.253a3.518,3.518,0,1,0,3.518,3.518h0a3.518,3.518,0,0,0-3.518-3.518",
    fill: "#dcccc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_103",
    "data-name": "Caminho 103",
    d: "M468.962,501.864c-.081,0-.044-.889-.451-2.4a9.941,9.941,0,0,0-3.649-5.326,9.7,9.7,0,0,0-9.168-1.33,9.651,9.651,0,0,0,0,18.114,9.7,9.7,0,0,0,9.168-1.33,9.953,9.953,0,0,0,3.649-5.325c.407-1.513.369-2.407.451-2.4a2.09,2.09,0,0,1,.042.641,7.846,7.846,0,0,1-.22,1.831A9.953,9.953,0,0,1,465.173,510a10.1,10.1,0,0,1-4.3,1.963,10.271,10.271,0,0,1-5.413-.411,10.28,10.28,0,1,1,9.464-18.019c.083.06.166.123.247.186a9.934,9.934,0,0,1,3.613,5.668,7.855,7.855,0,0,1,.22,1.832,2.093,2.093,0,0,1-.042.641",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_96",
    "data-name": "Ret\\xE2ngulo 96",
    width: 131.237,
    height: 12.28,
    transform: "translate(480.444 516.273)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_97",
    "data-name": "Ret\\xE2ngulo 97",
    width: 131.237,
    height: 6.159,
    transform: "translate(480.444 485.725)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_104",
    "data-name": "Caminho 104",
    d: "M573.707,489.979H485.086a1.013,1.013,0,0,1-1.014-1.011v-.387a1.013,1.013,0,0,1,1.011-1.014h88.624a1.012,1.012,0,0,1,1.013,1.012v.386a1.012,1.012,0,0,1-1.011,1.014h0",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_105",
    "data-name": "Caminho 105",
    d: "M586.362,489.979h-5.9a1.012,1.012,0,0,1-1.012-1.012v-.386a1.013,1.013,0,0,1,1.011-1.014h5.9a1.014,1.014,0,0,1,1.014,1.012v.386a1.013,1.013,0,0,1-1.011,1.014h0",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_98",
    "data-name": "Ret\\xE2ngulo 98",
    width: 0.993,
    height: 0.993,
    transform: "translate(591.58 487.397)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_99",
    "data-name": "Ret\\xE2ngulo 99",
    width: 0.993,
    height: 0.993,
    transform: "translate(591.58 488.71)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_100",
    "data-name": "Ret\\xE2ngulo 100",
    width: 0.993,
    height: 0.993,
    transform: "translate(593.126 487.397)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_101",
    "data-name": "Ret\\xE2ngulo 101",
    width: 0.993,
    height: 0.993,
    transform: "translate(593.126 488.71)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_102",
    "data-name": "Ret\\xE2ngulo 102",
    width: 131.237,
    height: 12.28,
    transform: "translate(480.444 491.883)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_103",
    "data-name": "Ret\\xE2ngulo 103",
    width: 3.715,
    height: 3.715,
    transform: "translate(484.072 495.892)",
    fill: "#0c4727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_106",
    "data-name": "Caminho 106",
    d: "M545.188,497.737c0,.2-12.045.366-26.9.366s-26.9-.163-26.9-.366,12.043-.366,26.9-.366,26.9.164,26.9.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_107",
    "data-name": "Caminho 107",
    d: "M595.892,497.636c0,.2-1.357.366-3.032.366s-3.032-.164-3.032-.366,1.358-.366,3.032-.366,3.032.164,3.032.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_104",
    "data-name": "Ret\\xE2ngulo 104",
    width: 131.237,
    height: 12.28,
    transform: "translate(480.444 528.454)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_105",
    "data-name": "Ret\\xE2ngulo 105",
    width: 3.751,
    height: 3.715,
    transform: "translate(483.572 532.463)",
    fill: "#0c4727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_108",
    "data-name": "Caminho 108",
    d: "M545.275,534.309c0,.2-12.161.366-27.158.366s-27.161-.164-27.161-.366,12.158-.366,27.161-.366,27.158.162,27.158.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_109",
    "data-name": "Caminho 109",
    d: "M596.463,534.208c0,.2-1.371.366-3.059.366s-3.061-.164-3.061-.366,1.369-.366,3.061-.366,3.059.163,3.059.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_106",
    "data-name": "Ret\\xE2ngulo 106",
    width: 131.237,
    height: 12.28,
    transform: "translate(480.444 540.554)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_107",
    "data-name": "Ret\\xE2ngulo 107",
    width: 3.751,
    height: 3.715,
    transform: "translate(483.572 544.561)",
    fill: "#0c4727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_110",
    "data-name": "Caminho 110",
    d: "M545.275,546.408c0,.2-12.161.366-27.158.366s-27.161-.163-27.161-.366,12.158-.366,27.161-.366,27.158.163,27.158.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_111",
    "data-name": "Caminho 111",
    d: "M596.463,546.307c0,.2-1.371.366-3.059.366s-3.061-.163-3.061-.366,1.369-.366,3.061-.366,3.059.164,3.059.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_108",
    "data-name": "Ret\\xE2ngulo 108",
    width: 131.237,
    height: 12.28,
    transform: "translate(480.444 552.653)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_109",
    "data-name": "Ret\\xE2ngulo 109",
    width: 3.751,
    height: 3.715,
    transform: "translate(483.572 556.661)",
    fill: "#0c4727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_112",
    "data-name": "Caminho 112",
    d: "M545.275,558.507c0,.2-12.161.366-27.158.366s-27.161-.163-27.161-.366,12.158-.366,27.161-.366,27.158.163,27.158.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_113",
    "data-name": "Caminho 113",
    d: "M596.463,558.406c0,.2-1.371.366-3.059.366s-3.061-.164-3.061-.366,1.369-.366,3.061-.366,3.059.163,3.059.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_110",
    "data-name": "Ret\\xE2ngulo 110",
    width: 131.237,
    height: 12.28,
    transform: "translate(480.444 564.752)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_111",
    "data-name": "Ret\\xE2ngulo 111",
    width: 3.751,
    height: 3.715,
    transform: "translate(483.572 568.76)",
    fill: "#0c4727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_114",
    "data-name": "Caminho 114",
    d: "M545.275,570.607c0,.2-12.161.366-27.158.366s-27.161-.164-27.161-.366,12.158-.367,27.161-.367,27.158.163,27.158.367",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_115",
    "data-name": "Caminho 115",
    d: "M596.463,570.505c0,.2-1.371.368-3.059.368s-3.061-.165-3.061-.368,1.369-.366,3.061-.366,3.059.164,3.059.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_112",
    "data-name": "Ret\\xE2ngulo 112",
    width: 131.255,
    height: 12.28,
    transform: "translate(480.425 504.007)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_113",
    "data-name": "Ret\\xE2ngulo 113",
    width: 3.715,
    height: 3.715,
    transform: "translate(484.072 508.015)",
    fill: "#0c4727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_116",
    "data-name": "Caminho 116",
    d: "M522.176,509.862c0,.2-6.893.366-15.4.366s-15.4-.164-15.4-.366,6.892-.366,15.4-.366,15.4.164,15.4.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_117",
    "data-name": "Caminho 117",
    d: "M595.892,510.217c0,.2-1.357.366-3.032.366s-3.032-.164-3.032-.366,1.358-.366,3.032-.366,3.032.164,3.032.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_118",
    "data-name": "Caminho 118",
    d: "M595.892,522.138c0,.2-1.357.366-3.032.366s-3.032-.164-3.032-.366,1.358-.366,3.032-.366,3.032.164,3.032.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_114",
    "data-name": "Ret\\xE2ngulo 114",
    width: 3.715,
    height: 3.715,
    transform: "translate(484.072 520.28)",
    fill: "#0c4727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_119",
    "data-name": "Caminho 119",
    d: "M565.57,522.127c0,.2-16.608.366-37.09.366s-37.095-.164-37.095-.366,16.6-.366,37.095-.366,37.09.164,37.09.366",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_120",
    "data-name": "Caminho 120",
    d: "M444.375,482.7a1.119,1.119,0,1,1-1.119-1.12,1.12,1.12,0,0,1,1.119,1.12h0",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_121",
    "data-name": "Caminho 121",
    d: "M448.738,482.7a1.119,1.119,0,1,1-1.119-1.12,1.118,1.118,0,0,1,1.119,1.12h0",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_122",
    "data-name": "Caminho 122",
    d: "M453.1,482.7a1.119,1.119,0,1,1-1.12-1.12,1.118,1.118,0,0,1,1.12,1.12v0",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_123",
    "data-name": "Caminho 123",
    d: "M611.68,577.03c0-2.245-.065-37.776-.169-97.475l.169.167-173.138.052h-.013l.22-.22c0,34.474-.01,67.442-.015,97.475l-.205-.205,173.151.205-173.151.206h-.206v-.206c0-30.034-.008-63-.014-97.475v-.22h.232l173.138.052h.169v.169c-.1,59.7-.165,95.231-.169,97.475",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_124",
    "data-name": "Caminho 124",
    d: "M696.328,856.338H685.744L662.137,644.354h13.888Z",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_125",
    "data-name": "Caminho 125",
    d: "M629.405,856.338H618.822L595.034,644.354h13.888Z",
    fill: "#b2aaaa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_126",
    "data-name": "Caminho 126",
    d: "M699.577,644.355H326.512V632.111H699.577Z",
    fill: "#edefe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_127",
    "data-name": "Caminho 127",
    d: "M403.943,856.338h10.584l22.708-211.984H423.347Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_128",
    "data-name": "Caminho 128",
    d: "M313.152,856.338h10.584L347.5,644.354H333.616Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_115",
    "data-name": "Ret\\xE2ngulo 115",
    width: 114.942,
    height: 12.244,
    transform: "translate(326.51 632.111)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_116",
    "data-name": "Ret\\xE2ngulo 116",
    width: 79.369,
    height: 3.66,
    transform: "translate(494.094 628.45)",
    fill: "#0b3d20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_129",
    "data-name": "Caminho 129",
    d: "M663.58,808.107l7.508,41.244-51.266,9.6C619.2,854,643.885,839.2,643.885,839.2l-5.9-26.228Z",
    fill: "#0c4727"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_89",
    "data-name": "Grupo 89",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_88",
    "data-name": "Grupo 88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_183",
    "data-name": "Grupo 183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_182",
    "data-name": "Grupo 182",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_87",
    "data-name": "Grupo 87"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_130",
    "data-name": "Caminho 130",
    d: "M659.316,834.006a2.127,2.127,0,0,1,1.894,2.118,2.046,2.046,0,0,1-2.082,1.9,2.247,2.247,0,0,1-1.995-2.253,2.126,2.126,0,0,1,2.385-1.734",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_92",
    "data-name": "Grupo 92",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_91",
    "data-name": "Grupo 91"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_185",
    "data-name": "Grupo 185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_184",
    "data-name": "Grupo 184",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_90",
    "data-name": "Grupo 90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_131",
    "data-name": "Caminho 131",
    d: "M671.082,849.348l-.919-4.128-48.805,10.75s-2.1,1.422-1.539,2.982Z",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_132",
    "data-name": "Caminho 132",
    d: "M643,839.087c.055.25,1.329.129,2.711.7,1.4.537,2.235,1.5,2.447,1.361.22-.092-.432-1.518-2.118-2.185s-3.138-.1-3.04.121",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_133",
    "data-name": "Caminho 133",
    d: "M638.041,842.324c-.014.252,1.153.475,2.2,1.375,1.074.868,1.5,1.973,1.751,1.917.242-.006.141-1.505-1.184-2.6s-2.807-.933-2.768-.693",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_134",
    "data-name": "Caminho 134",
    d: "M636.192,849.331c.237.011.351-1.3-.55-2.556s-2.173-1.576-2.24-1.348c-.1.232.8.824,1.518,1.868.747,1.02,1.016,2.064,1.269,2.04",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_135",
    "data-name": "Caminho 135",
    d: "M642.32,832.966c.147.207,1.231-.352,2.664-.521,1.429-.2,2.62.07,2.711-.17.11-.207-1.139-.933-2.823-.711s-2.71,1.227-2.551,1.4",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_136",
    "data-name": "Caminho 136",
    d: "M642.4,826.654a4.9,4.9,0,0,0,2.566-.494,11.8,11.8,0,0,0,2.528-1.329,12.39,12.39,0,0,0,1.327-1.058,3.226,3.226,0,0,0,.659-.749,1.11,1.11,0,0,0-.134-1.354,1.4,1.4,0,0,0-1.209-.367,3.419,3.419,0,0,0-.938.313,9.222,9.222,0,0,0-3.57,2.845,4.378,4.378,0,0,0-1.119,2.367c.129.061.561-.83,1.6-1.967a10.418,10.418,0,0,1,2.049-1.72,9.717,9.717,0,0,1,1.387-.731c.516-.243.978-.33,1.163-.119.067.081.081.117,0,.3a2.626,2.626,0,0,1-.487.549,13.78,13.78,0,0,1-1.209,1.03,14.519,14.519,0,0,1-2.309,1.416,18.11,18.11,0,0,0-2.316,1.07",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_137",
    "data-name": "Caminho 137",
    d: "M642.794,826.952a4.161,4.161,0,0,0,.212-2.606,8.441,8.441,0,0,0-1.823-4.178,2.161,2.161,0,0,0-1.879-.989,1.223,1.223,0,0,0-.939.918,3.5,3.5,0,0,0-.087.989,5.818,5.818,0,0,0,.322,1.729,6.009,6.009,0,0,0,1.593,2.446c1.251,1.141,2.351,1.245,2.358,1.156.059-.141-.9-.461-1.91-1.593a6.034,6.034,0,0,1-1.264-2.26,5.4,5.4,0,0,1-.231-1.493c-.021-.561.1-1.038.316-1.02.253-.052.769.277,1.055.673a8.8,8.8,0,0,1,.9,1.271,9.4,9.4,0,0,1,.977,2.47c.353,1.492.261,2.479.4,2.491",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_138",
    "data-name": "Caminho 138",
    d: "M603.819,814.75l8.054,41.14-51.128,10.281c-.683-4.946,23.8-20.072,23.8-20.072L578.3,819.952Z",
    fill: "#0c4727"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_95",
    "data-name": "Grupo 95",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_94",
    "data-name": "Grupo 94"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_187",
    "data-name": "Grupo 187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_186",
    "data-name": "Grupo 186",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_93",
    "data-name": "Grupo 93"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_139",
    "data-name": "Caminho 139",
    d: "M599.909,840.709a2.13,2.13,0,0,1,1.923,2.088,2.047,2.047,0,0,1-2.058,1.924,2.245,2.245,0,0,1-2.024-2.222,2.124,2.124,0,0,1,2.362-1.765",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_98",
    "data-name": "Grupo 98",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_97",
    "data-name": "Grupo 97"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_189",
    "data-name": "Grupo 189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_188",
    "data-name": "Grupo 188",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_96",
    "data-name": "Grupo 96"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_140",
    "data-name": "Caminho 140",
    d: "M611.878,855.892l-.974-4.115-48.662,11.4s-2.078,1.448-1.5,3Z",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_141",
    "data-name": "Caminho 141",
    d: "M583.666,846.01c.059.248,1.33.11,2.719.666,1.406.519,2.256,1.475,2.466,1.329.22-.094-.452-1.512-2.147-2.155s-3.138-.056-3.038.161",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_142",
    "data-name": "Caminho 142",
    d: "M578.742,849.306c-.008.253,1.159.46,2.22,1.345,1.085.854,1.53,1.954,1.776,1.893.242-.009.121-1.505-1.219-2.581s-2.818-.9-2.777-.659",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_143",
    "data-name": "Caminho 143",
    d: "M576.989,856.338c.238.008.33-1.311-.582-2.55s-2.193-1.546-2.256-1.319c-.1.235.8.815,1.539,1.844.759,1.01,1.043,2.049,1.3,2.024",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_144",
    "data-name": "Caminho 144",
    d: "M582.9,839.893c.15.207,1.226-.368,2.657-.556,1.429-.22,2.62.035,2.707-.2.11-.21-1.15-.919-2.832-.673s-2.7,1.262-2.528,1.429",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_145",
    "data-name": "Caminho 145",
    d: "M582.9,833.581a4.9,4.9,0,0,0,2.559-.527,11.8,11.8,0,0,0,2.514-1.362,12.309,12.309,0,0,0,1.313-1.076,3.2,3.2,0,0,0,.653-.758,1.109,1.109,0,0,0-.154-1.351,1.4,1.4,0,0,0-1.209-.35,3.366,3.366,0,0,0-.933.329,9.236,9.236,0,0,0-3.533,2.891,4.367,4.367,0,0,0-1.088,2.383c.13.061.549-.837,1.575-1.987a10.422,10.422,0,0,1,2.025-1.747,9.766,9.766,0,0,1,1.379-.748c.514-.252.973-.348,1.161-.135.069.081.081.116,0,.3a2.629,2.629,0,0,1-.481.55,13.618,13.618,0,0,1-1.2,1.044,14.43,14.43,0,0,1-2.286,1.447,17.757,17.757,0,0,0-2.3,1.1",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_146",
    "data-name": "Caminho 146",
    d: "M583.3,833.874a4.177,4.177,0,0,0,.177-2.61,8.44,8.44,0,0,0-1.878-4.157,2.157,2.157,0,0,0-1.893-.964,1.215,1.215,0,0,0-.925.929,3.494,3.494,0,0,0-.075.989,5.8,5.8,0,0,0,.345,1.726,6.015,6.015,0,0,0,1.626,2.425c1.266,1.124,2.369,1.209,2.373,1.124.057-.142-.91-.448-1.931-1.57a6.009,6.009,0,0,1-1.294-2.243,5.348,5.348,0,0,1-.251-1.49c-.029-.56.086-1.038.3-1.024.253-.055.77.267,1.065.66a8.745,8.745,0,0,1,.913,1.26,9.421,9.421,0,0,1,1.01,2.456c.372,1.486.293,2.474.44,2.485",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_147",
    "data-name": "Caminho 147",
    d: "M633.661,822.974l-19.883-110.7a31.654,31.654,0,0,1,31.153-37.247h70.136l45.83,20.313a28.409,28.409,0,0,1-28.409,28.409q-1.113,0-2.223-.087L655.42,717.79l10.785,100.272Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_148",
    "data-name": "Caminho 148",
    d: "M575.648,828.835,552.956,712.272a31.647,31.647,0,0,1,31.153-37.247h70.136l45.832,20.312v30.727L594.6,717.789l13.816,103.583Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_149",
    "data-name": "Caminho 149",
    d: "M608.416,821.372a8.2,8.2,0,0,1-.241-1.241q-.2-1.318-.549-3.576c-.452-3.179-1.091-7.662-1.874-13.175-1.522-11.191-3.607-26.543-5.911-43.5-2.134-16.287-4.073-31.09-5.508-42.054l.116.186c-5.024-3.454-8.85-6.55-11.586-8.565l-3.144-2.329a9.527,9.527,0,0,1-1.086-.83,1.156,1.156,0,0,1,.307.162l.864.542c.753.487,1.847,1.231,3.234,2.217,2.791,1.943,6.677,4.98,11.707,8.359l.1.067.017.12,5.705,42.028c2.222,16.969,4.232,32.33,5.7,43.53.688,5.525,1.247,10.018,1.649,13.205q.257,2.268.411,3.595a8.182,8.182,0,0,1,.093,1.26",
    fill: "#1f0735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_150",
    "data-name": "Caminho 150",
    d: "M542.011,628.709l4.976-9.324a2.983,2.983,0,0,1,2.62-1.319l2.224.1,3.787-3.534h4.42l3.408-2.271,13.126,2.528,10.8,2.906-6.149,12.207-6.165-1.3-10.349-.177a11.633,11.633,0,0,1-7.983-3.362,9.834,9.834,0,0,0-6.912-2.841s-3.251,7.269-7.8,6.387",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_153",
    "data-name": "Caminho 153",
    d: "M657.782,553.854c-6.376,4.552-3.754,16.768-3.84,23.176-.192,14.3,1.165,27.722,1.914,29.969,1.094,3.28,5.056,31.233,5.056,31.233l-6.668,36.794s8.612,21.971,45.832,21.751l18.548-4.429a19.261,19.261,0,0,0,14.717-20.373l-4.221-49.411-5.624-40.1c-1.471-21.042-14.651-32.238-31.492-31.039Z",
    fill: "#0c4727"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_101",
    "data-name": "Grupo 101",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_100",
    "data-name": "Grupo 100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_191",
    "data-name": "Grupo 191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_190",
    "data-name": "Grupo 190",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_99",
    "data-name": "Grupo 99"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_154",
    "data-name": "Caminho 154",
    d: "M673.058,691.979c-4.067-2.118,1.4-43.258,6.155-64.325,1.855-8.213,4.318-16.708,10.154-22.776,4.6-4.78,10.92-7.61,17.389-9.063s11.73-1.635,18.357-1.811l5.838,93.644s-40.372,13.443-57.9,4.331",
    fill: "#0b3d20"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_155",
    "data-name": "Caminho 155",
    d: "M657.782,553.854a25.249,25.249,0,0,0-18.095,13.992c-4.689,9.727-25.193,50.224-25.193,50.224l-31.348-2.088-6.266,14.3L619.9,641.816c8.859,1.7,16.6-3.71,20.97-11.7l18.014-32.959Z",
    fill: "#0c4727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_157",
    "data-name": "Caminho 157",
    d: "M618.219,625.135c-.146.126-1.354-1.094-2.279-2.968s-1.173-3.57-.989-3.611c.206-.052.748,1.5,1.642,3.287s1.787,3.163,1.622,3.3",
    fill: "#0b3d20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_158",
    "data-name": "Caminho 158",
    d: "M663.125,585.964c.185.083-1.892,5.056-4.635,11.11s-5.118,10.89-5.3,10.806,1.889-5.056,4.635-11.11,5.118-10.89,5.3-10.806",
    fill: "#0b3d20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_160",
    "data-name": "Caminho 160",
    d: "M642.9,562.867c.181.093-5.981,12.354-13.76,27.379s-14.234,27.139-14.413,27.042,5.98-12.351,13.761-27.383,14.231-27.137,14.411-27.041",
    fill: "#089fb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_161",
    "data-name": "Caminho 161",
    d: "M654.69,571.877c0-.04.278-.079.726.11a2.479,2.479,0,0,1,1.342,1.515,2.609,2.609,0,0,1-1,2.84,2.959,2.959,0,0,1-1.792.506c-.627,0-1.227-.12-1.813-.162a3.448,3.448,0,0,0-2.858,1.048,3.309,3.309,0,0,0-.927,2.355,5.724,5.724,0,0,0,.736,2.374c-.01.079-1.053-.579-1.252-2.348a3.717,3.717,0,0,1,.949-2.841,4.032,4.032,0,0,1,3.407-1.319c1.269.129,2.4.382,3.164-.166a2.086,2.086,0,0,0,.889-2.149,2.382,2.382,0,0,0-.98-1.4c-.353-.243-.6-.306-.588-.363",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_162",
    "data-name": "Caminho 162",
    d: "M696.245,572.337c0-.041.279-.079.726.11a2.481,2.481,0,0,1,1.343,1.514,2.611,2.611,0,0,1-1,2.841,2.954,2.954,0,0,1-1.792.505c-.626,0-1.226-.119-1.812-.161a3.442,3.442,0,0,0-2.858,1.047,3.307,3.307,0,0,0-.929,2.355,5.735,5.735,0,0,0,.736,2.374c-.009.079-1.053-.579-1.252-2.348a3.718,3.718,0,0,1,.949-2.84,4.03,4.03,0,0,1,3.408-1.319c1.268.13,2.4.381,3.163-.166a2.09,2.09,0,0,0,.89-2.149,2.388,2.388,0,0,0-.981-1.4c-.352-.243-.6-.3-.588-.362",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_163",
    "data-name": "Caminho 163",
    d: "M695.74,602.383c.039.014.01.29-.282.678a2.479,2.479,0,0,1-1.792.942,2.61,2.61,0,0,1-2.517-1.648,2.963,2.963,0,0,1-.062-1.861c.154-.607.41-1.162.592-1.722a3.441,3.441,0,0,0-.33-3.028,3.3,3.3,0,0,0-2.063-1.466,5.73,5.73,0,0,0-2.481.147,2.781,2.781,0,0,1,2.58-.66,3.712,3.712,0,0,1,2.528,1.6,4.03,4.03,0,0,1,.464,3.627c-.429,1.2-.946,2.24-.6,3.112a2.1,2.1,0,0,0,1.874,1.38,2.389,2.389,0,0,0,1.6-.618c.32-.285.44-.509.492-.484",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_164",
    "data-name": "Caminho 164",
    d: "M677.521,645.005c.038.013.009.291-.283.679a2.477,2.477,0,0,1-1.792.94,2.61,2.61,0,0,1-2.517-1.649,2.955,2.955,0,0,1-.061-1.861c.153-.607.41-1.164.591-1.721a3.443,3.443,0,0,0-.33-3.029,3.3,3.3,0,0,0-2.063-1.465,5.684,5.684,0,0,0-2.481.146,2.776,2.776,0,0,1,2.58-.659,3.711,3.711,0,0,1,2.528,1.6,4.032,4.032,0,0,1,.465,3.628c-.43,1.2-.945,2.24-.6,3.112a2.1,2.1,0,0,0,1.874,1.377,2.4,2.4,0,0,0,1.6-.617c.32-.284.44-.509.493-.486",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_165",
    "data-name": "Caminho 165",
    d: "M714.864,582.662c0-.041.279-.079.726.11a2.477,2.477,0,0,1,1.342,1.514,2.609,2.609,0,0,1-1,2.841,2.963,2.963,0,0,1-1.792.506c-.626,0-1.227-.12-1.812-.162a3.446,3.446,0,0,0-2.858,1.048,3.3,3.3,0,0,0-.928,2.354,5.735,5.735,0,0,0,.736,2.374c-.01.08-1.053-.579-1.253-2.348a3.716,3.716,0,0,1,.949-2.84,4.03,4.03,0,0,1,3.407-1.319c1.269.127,2.4.381,3.164-.166a2.088,2.088,0,0,0,.889-2.149,2.385,2.385,0,0,0-.98-1.4c-.353-.242-.6-.3-.588-.362",
    fill: "#0b3d20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_166",
    "data-name": "Caminho 166",
    d: "M671.468,620.415c-.036.019-.212-.2-.28-.678a2.483,2.483,0,0,1,.6-1.935,2.614,2.614,0,0,1,2.948-.617,2.961,2.961,0,0,1,1.362,1.27c.321.538.533,1.11.8,1.633a3.437,3.437,0,0,0,2.38,1.9,3.308,3.308,0,0,0,2.494-.427,5.763,5.763,0,0,0,1.649-1.862c.072-.031.05,1.2-1.356,2.289a3.718,3.718,0,0,1-2.921.66,4.031,4.031,0,0,1-2.9-2.231c-.55-1.15-.921-2.25-1.785-2.619a2.088,2.088,0,0,0-2.3.355,2.383,2.383,0,0,0-.689,1.566c-.024.428.05.672,0,.692",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_167",
    "data-name": "Caminho 167",
    d: "M673.506,592.169c0-.041.279-.079.727.11a2.482,2.482,0,0,1,1.342,1.515,2.61,2.61,0,0,1-1,2.84,2.96,2.96,0,0,1-1.791.506c-.627,0-1.227-.12-1.813-.162a3.44,3.44,0,0,0-2.858,1.048,3.3,3.3,0,0,0-.929,2.354,5.724,5.724,0,0,0,.737,2.375c-.01.079-1.053-.58-1.252-2.348a3.72,3.72,0,0,1,.948-2.841,4.032,4.032,0,0,1,3.408-1.319c1.268.129,2.4.382,3.164-.166a2.089,2.089,0,0,0,.889-2.149,2.381,2.381,0,0,0-.981-1.4c-.351-.243-.6-.306-.588-.363",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_168",
    "data-name": "Caminho 168",
    d: "M672.661,659.012c0-.04.279-.079.726.11a2.48,2.48,0,0,1,1.343,1.515,2.61,2.61,0,0,1-1,2.84,2.956,2.956,0,0,1-1.792.506c-.626,0-1.226-.12-1.812-.162a3.446,3.446,0,0,0-2.858,1.048,3.31,3.31,0,0,0-.928,2.355,5.726,5.726,0,0,0,.737,2.374c-.01.079-1.054-.579-1.254-2.348a3.717,3.717,0,0,1,.949-2.841,4.033,4.033,0,0,1,3.408-1.319c1.268.129,2.4.382,3.163-.166a2.089,2.089,0,0,0,.89-2.149,2.388,2.388,0,0,0-.981-1.4c-.353-.243-.6-.306-.588-.363",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_169",
    "data-name": "Caminho 169",
    d: "M632.86,623.389c0-.04.279-.079.726.11a2.483,2.483,0,0,1,1.343,1.515,2.611,2.611,0,0,1-1,2.841,2.961,2.961,0,0,1-1.792.505c-.626,0-1.226-.12-1.812-.161a3.439,3.439,0,0,0-2.858,1.047,3.307,3.307,0,0,0-.929,2.355,5.734,5.734,0,0,0,.736,2.374c-.009.079-1.053-.579-1.252-2.348a3.713,3.713,0,0,1,.949-2.84,4.03,4.03,0,0,1,3.408-1.319c1.268.128,2.4.381,3.163-.166a2.09,2.09,0,0,0,.89-2.149,2.388,2.388,0,0,0-.981-1.4c-.352-.243-.6-.306-.588-.363",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_170",
    "data-name": "Caminho 170",
    d: "M643.481,603.923c.039.007.054.286-.177.712a2.485,2.485,0,0,1-1.631,1.2,2.614,2.614,0,0,1-2.739-1.257,2.967,2.967,0,0,1-.341-1.829c.061-.623.231-1.209.33-1.79a3.44,3.44,0,0,0-.782-2.946,3.3,3.3,0,0,0-2.262-1.137,5.736,5.736,0,0,0-2.43.518c-.077-.017.673-1,2.451-1.036a3.722,3.722,0,0,1,2.742,1.2,4.032,4.032,0,0,1,1,3.518c-.242,1.251-.6,2.355-.12,3.164a2.088,2.088,0,0,0,2.06,1.081,2.392,2.392,0,0,0,1.485-.85c.272-.33.357-.57.413-.549",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_171",
    "data-name": "Caminho 171",
    d: "M673.9,568.355c.04.007.054.286-.177.713a2.48,2.48,0,0,1-1.63,1.2,2.611,2.611,0,0,1-2.738-1.255,2.971,2.971,0,0,1-.341-1.83c.061-.623.231-1.209.33-1.79a3.436,3.436,0,0,0-.783-2.946,3.294,3.294,0,0,0-2.261-1.137,5.735,5.735,0,0,0-2.43.518c-.077-.019.673-1,2.451-1.035a3.713,3.713,0,0,1,2.742,1.2,4.033,4.033,0,0,1,1,3.518c-.243,1.252-.6,2.358-.121,3.167a2.089,2.089,0,0,0,2.06,1.08,2.387,2.387,0,0,0,1.485-.85c.273-.329.358-.569.414-.549",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_172",
    "data-name": "Caminho 172",
    d: "M714.677,565.94c.039.007.054.286-.177.713a2.492,2.492,0,0,1-1.631,1.2,2.614,2.614,0,0,1-2.738-1.256,2.971,2.971,0,0,1-.34-1.83c.06-.623.231-1.209.329-1.79a3.435,3.435,0,0,0-.783-2.946,3.3,3.3,0,0,0-2.26-1.137,5.725,5.725,0,0,0-2.431.518c-.077-.016.673-1,2.452-1.035a3.715,3.715,0,0,1,2.741,1.2,4.033,4.033,0,0,1,1.005,3.518c-.243,1.251-.6,2.355-.121,3.164a2.089,2.089,0,0,0,2.059,1.081,2.392,2.392,0,0,0,1.486-.85c.272-.329.357-.57.413-.549",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_173",
    "data-name": "Caminho 173",
    d: "M607.383,628.469c.04.007.054.286-.177.712a2.484,2.484,0,0,1-1.63,1.2,2.611,2.611,0,0,1-2.738-1.256,2.97,2.97,0,0,1-.347-1.827c.061-.623.231-1.209.33-1.79a3.439,3.439,0,0,0-.784-2.946,3.3,3.3,0,0,0-2.26-1.137,5.737,5.737,0,0,0-2.43.518c-.077-.019.673-1,2.451-1.036a3.716,3.716,0,0,1,2.742,1.2,4.032,4.032,0,0,1,1,3.518c-.243,1.252-.6,2.358-.12,3.167a2.086,2.086,0,0,0,2.058,1.08,2.392,2.392,0,0,0,1.487-.85c.272-.329.357-.57.413-.549",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_174",
    "data-name": "Caminho 174",
    d: "M672.743,732.568l-1.111,123.774h7.049l.526-121.307s.352-5.543,4.58-5.913,67.559,2.822,67.559,2.822l18.664,124.4h8.1L759.886,731.956s-53.19-17.99-79.623-12.446c0,0-6.345-1.17-6.7,3.7s-.824,9.363-.824,9.363",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_175",
    "data-name": "Caminho 175",
    d: "M673.981,718.265s11-85.815,14.961-100.392a26.3,26.3,0,0,1,12.2-15.583,20.677,20.677,0,0,1,11.167-2.958l58.421,1.28a8.829,8.829,0,0,1,8.521,10.223l-19.368,121.12c-21.5-.054-71.8,0-71.8,0s-68.812-7.512-79.375-7.973c-6.607-.288-7.1,2.251-7.657,5.021h0c-6.194-5.02-2.5-15.328,5.459-14.84Z",
    fill: "#edefe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_176",
    "data-name": "Caminho 176",
    d: "M778.846,606.5a2.556,2.556,0,0,1-.5.038l-1.472.035-5.662.07-20.819.116-14.376.045-8.009.019-4.188.009c-1.415.009-2.858-.027-4.267.089A15.738,15.738,0,0,0,706.3,617.391a26.482,26.482,0,0,0-.989,4.609q-.388,2.38-.784,4.8-.79,4.838-1.6,9.8c-4.378,26.453-8.338,50.394-11.213,67.775l-3.48,20.526c-.421,2.386-.752,4.256-.984,5.574-.109.606-.2,1.084-.272,1.447a2.487,2.487,0,0,1-.119.488,2.631,2.631,0,0,1,.044-.5c.051-.366.119-.848.2-1.458.2-1.319.484-3.2.848-5.6.769-4.9,1.883-11.913,3.249-20.563,2.822-17.389,6.706-41.346,11-67.812q.813-4.961,1.607-9.8l.789-4.8a26.97,26.97,0,0,1,1.027-4.726,16.42,16.42,0,0,1,13.866-10.907c1.492-.11,2.917-.071,4.333-.077l4.188.009,8.009.018,14.376.046,20.82.116,5.662.069,1.472.036a2.555,2.555,0,0,1,.5.038",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_177",
    "data-name": "Caminho 177",
    d: "M600.944,732.568l-3.208,123.774h7.049l1.827-121.114s.086-7.21,5.579-6.609c4.221.462,68.169,7.895,68.169,7.895l21.529,119.827H710L688.085,731.956l-78.375-9.875a8.369,8.369,0,0,0-4.784.723,6.967,6.967,0,0,0-3.87,6.2c-.343,4.869-.11,3.568-.11,3.568",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_178",
    "data-name": "Caminho 178",
    d: "M760.9,600.4s-39.463,128.3-86.919,117.868l.785-6.045s36.68,6.094,79.839-111.958Z",
    fill: "#daa520"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_179",
    "data-name": "Caminho 179",
    d: "M677.373,716.83a110.453,110.453,0,0,0,7.715,39c1.429,3.6,3.3,7.4,6.787,9.086,3.455,1.668,7.552.8,11.249-.22a171.145,171.145,0,0,0,26.831-9.875c3.172-1.48,6.5-3.245,8.123-6.346,1.938-3.7.918-8.187-.19-12.212q-5.325-19.391-11.955-38.394c-.919-2.638-5.144-12.818-5.144-12.818",
    fill: "#daa520"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_180",
    "data-name": "Caminho 180",
    d: "M725.534,700.241a2.589,2.589,0,0,1,.019.687c0,.451-.05,1.11-.122,1.96a41.068,41.068,0,0,1-1.345,7.106,37.14,37.14,0,0,1-4.375,9.8,31.326,31.326,0,0,1-9.221,9.353,26.615,26.615,0,0,1-12.39,4.336,24.254,24.254,0,0,1-10.614-1.576,21.244,21.244,0,0,1-6.2-3.737,14.9,14.9,0,0,1-1.4-1.39,2.523,2.523,0,0,1-.427-.538c.057-.054.686.653,2.005,1.708a22.7,22.7,0,0,0,6.2,3.47,24.349,24.349,0,0,0,10.374,1.387,26.4,26.4,0,0,0,12.045-4.277,31.341,31.341,0,0,0,9.054-9.107,38.148,38.148,0,0,0,4.445-9.583,47.8,47.8,0,0,0,1.556-6.993c.246-1.679.329-2.618.388-2.614",
    fill: "#aa7a13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_181",
    "data-name": "Caminho 181",
    d: "M706.844,735.92c-.2-.014-.181-2.765.048-6.14s.577-6.107.779-6.092.181,2.762-.048,6.141-.578,6.105-.779,6.091",
    fill: "#aa7a13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_182",
    "data-name": "Caminho 182",
    d: "M280.744,763.643c10.249,3.579,23.619.381,32.388-6.022s15.076-15.575,20.665-24.88c2.387-3.971,4.716-8.112,5.471-12.682s-.356-9.714-3.9-12.7c-5.509-4.635-13.951-2.284-20.207,1.28a69.68,69.68,0,0,0-34.418,55",
    fill: "#daa520"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_183",
    "data-name": "Caminho 183",
    d: "M291.748,788.174c6.156,8.12,16.731,11.737,26.911,12.207s20.237-2.343,29.749-5.994c3.453-1.319,7.229-3.139,8.412-6.641a8.446,8.446,0,0,0-1.8-7.836,17.572,17.572,0,0,0-6.869-4.683c-9.366-3.99-20.093-4.177-29.945-1.621s-18.461,8.267-26.456,14.566",
    fill: "#daa520"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_184",
    "data-name": "Caminho 184",
    d: "M280.594,719.735c8.485.169,14.907-7.264,18.748-14.83a54.964,54.964,0,0,0,5.056-34.273c-.775-4.336-2.418-9.013-6.3-11.1-3.943-2.12-9.073-.724-12.38,2.294s-5.123,7.325-6.442,11.6c-4.554,14.736-3.574,31.671,1.31,46.3",
    fill: "#daa520"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_185",
    "data-name": "Caminho 185",
    d: "M252.726,766.663c14.466-24.622,16.876-54.741,8.333-81.99-1.386-4.419-4-9.478-8.625-9.77-5.12-.33-8.329,5.386-9.743,10.314-4.96,17.3-3.906,35.679-2.809,53.642.677,11.066,4.477,20.527,12.844,27.8",
    fill: "#daa520"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_186",
    "data-name": "Caminho 186",
    d: "M237.683,776.787a59.168,59.168,0,0,0-35.1-37.224c-3.847-1.446-8.726-2.27-11.592.668-2.81,2.884-1.944,7.7-.141,11.3,2.913,5.815,7.642,10.486,12.352,14.97,4.287,4.077,8.736,8.171,14.157,10.541s15.37,2.973,20.326-.258",
    fill: "#daa520"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_187",
    "data-name": "Caminho 187",
    d: "M327.368,713.534a1.182,1.182,0,0,1-.252.22l-.779.6-3.032,2.267-2.2,1.624c-.79.611-1.616,1.319-2.522,2.053-1.791,1.5-3.907,3.107-6.036,5.132l-3.407,3.1c-1.18,1.084-2.315,2.309-3.544,3.518-2.49,2.394-4.9,5.187-7.495,8.074A159.348,159.348,0,0,0,271.662,782.9c-1.421,3.611-2.841,7.018-3.87,10.314-.537,1.641-1.124,3.205-1.563,4.745s-.85,3.021-1.249,4.436c-.86,2.811-1.354,5.424-1.892,7.7-.252,1.138-.517,2.193-.709,3.173q-.255,1.47-.468,2.694l-.673,3.726c-.077.391-.141.709-.191.967a1.4,1.4,0,0,1-.089.33,1.122,1.122,0,0,1,.02-.337c.031-.26.073-.581.124-.977q.2-1.367.549-3.75.188-1.229.412-2.71c.174-.989.421-2.047.659-3.188.5-2.284.965-4.913,1.8-7.741l1.21-4.462c.43-1.55,1-3.122,1.532-4.771,1.009-3.319,2.418-6.746,3.826-10.377a155.92,155.92,0,0,1,26.546-42.947c2.617-2.885,5.056-5.674,7.57-8.062,1.24-1.209,2.39-2.426,3.584-3.5l3.45-3.078c2.158-2.008,4.3-3.6,6.119-5.069.919-.723,1.759-1.416,2.563-2.014l2.239-1.58,3.11-2.165.819-.55a1.221,1.221,0,0,1,.291-.167",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_188",
    "data-name": "Caminho 188",
    d: "M346.525,781.785a5.522,5.522,0,0,1-.989-.166c-.649-.109-1.586-.366-2.817-.57a79.31,79.31,0,0,0-10.474-1.282,76.424,76.424,0,0,0-62.051,25.821,79.555,79.555,0,0,0-6.473,8.331c-.723,1.019-1.209,1.859-1.58,2.4a5.3,5.3,0,0,1-.583.82,5.617,5.617,0,0,1,.465-.89c.336-.566.785-1.429,1.476-2.476a70.761,70.761,0,0,1,6.332-8.505,75.187,75.187,0,0,1,62.444-25.982,70.526,70.526,0,0,1,10.5,1.5c1.226.246,2.157.538,2.8.7a5.686,5.686,0,0,1,.96.3",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_189",
    "data-name": "Caminho 189",
    d: "M293.1,669.366a1.647,1.647,0,0,1-.056.382c-.059.286-.135.65-.23,1.106l-.95,4.238c-.833,3.679-2.1,8.987-3.7,15.539-3.188,13.106-7.819,31.153-12.642,51.151-2.4,10-4.567,19.567-6.438,28.279-1.833,8.721-3.4,16.6-4.564,23.235-.624,3.313-1.1,6.325-1.539,8.966s-.8,4.917-1.078,6.783c-.282,1.826-.507,3.261-.667,4.287-.079.459-.141.825-.19,1.114a1.816,1.816,0,0,1-.089.377,1.721,1.721,0,0,1,.018-.386c.032-.291.074-.659.124-1.123.13-1.034.312-2.476.542-4.309.231-1.869.543-4.159.963-6.807s.848-5.667,1.441-8.988c1.1-6.656,2.623-14.545,4.427-23.281,1.838-8.728,3.991-18.3,6.39-28.308,4.827-20.006,9.532-38.034,12.838-51.115,1.642-6.5,2.975-11.779,3.911-15.483.457-1.791.818-3.2,1.075-4.208l.3-1.091a1.6,1.6,0,0,1,.124-.366",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_190",
    "data-name": "Caminho 190",
    d: "M259.883,812.844a1.064,1.064,0,0,1-.092-.3c-.054-.239-.12-.531-.2-.888q-.261-1.259-.712-3.427c-.612-2.978-1.429-7.3-2.351-12.659-1.855-10.71-4.055-25.587-5.407-42.13-.66-8.275-1.021-16.177-1.18-23.367-.12-7.19-.057-13.67.167-19.1.066-2.72.245-5.173.365-7.33s.262-4.011.4-5.524l.321-3.486c.041-.363.074-.66.1-.9a1.021,1.021,0,0,1,.056-.305,1.053,1.053,0,0,1,.013.312c-.009.245-.02.549-.034.909-.046.855-.11,2.022-.193,3.493-.1,1.516-.212,3.37-.287,5.528s-.226,4.608-.262,7.324c-.162,5.427-.175,11.895-.021,19.073.194,7.178.577,15.06,1.231,23.326,1.35,16.518,3.472,31.384,5.2,42.106.865,5.363,1.6,9.7,2.138,12.688q.369,2.181.586,3.451c.055.362.1.659.136.9a1.083,1.083,0,0,1,.022.311",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_191",
    "data-name": "Caminho 191",
    d: "M260.953,815.972a4.815,4.815,0,0,1-.377-.85c-.241-.631-.558-1.452-.953-2.477q-.307-.816-.678-1.79-.434-.967-.929-2.08t-1.061-2.393c-.374-.848-.859-1.7-1.319-2.622l-1.476-2.87q-.849-1.457-1.759-3.024c-1.163-2.124-2.664-4.233-4.113-6.531a154.46,154.46,0,0,0-10.9-13.924,171.477,171.477,0,0,0-12.5-12.516c-2.079-1.759-3.983-3.508-5.907-4.978l-2.737-2.181-2.6-1.917c-1.642-1.245-3.188-2.287-4.544-3.2-1.345-.932-2.52-1.708-3.508-2.3l-2.243-1.42a4.963,4.963,0,0,1-.758-.536,4.683,4.683,0,0,1,.828.416l2.308,1.314c1.012.558,2.211,1.3,3.58,2.208,1.382.88,2.952,1.9,4.617,3.124l2.638,1.889,2.773,2.159c1.947,1.456,3.872,3.2,5.971,4.946a162.254,162.254,0,0,1,12.6,12.531,147.2,147.2,0,0,1,10.9,14.027c1.446,2.32,2.936,4.451,4.083,6.6l1.733,3.059q.752,1.514,1.444,2.905c.448.932.919,1.8,1.28,2.656s.7,1.663,1.019,2.418.608,1.458.879,2.111l.625,1.818c.346,1.044.622,1.883.834,2.528a4.7,4.7,0,0,1,.246.894",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_192",
    "data-name": "Caminho 192",
    d: "M322.005,742.093c0,.11-1.759.11-4.57.265a81.84,81.84,0,0,0-21.565,4.1c-2.677.885-4.306,1.527-4.348,1.429a4.331,4.331,0,0,1,1.086-.589c.714-.345,1.774-.789,3.1-1.294a65.051,65.051,0,0,1,21.709-4.123c1.419-.017,2.566.009,3.359.066a4.275,4.275,0,0,1,1.227.15",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_193",
    "data-name": "Caminho 193",
    d: "M332.918,795.394c-.206.11-1.842-4.609-5.955-8.982-4.058-4.424-8.64-6.4-8.516-6.6a10.109,10.109,0,0,1,2.94,1.3,25.98,25.98,0,0,1,10.453,11.255,10.2,10.2,0,0,1,1.079,3.028",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_194",
    "data-name": "Caminho 194",
    d: "M295.7,689.353c.138.146-2.528,2.787-5.432,6.365s-4.972,6.7-5.144,6.6c-.152-.086,1.658-3.421,4.616-7.035s5.848-6.066,5.961-5.936",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_195",
    "data-name": "Caminho 195",
    d: "M286.962,674.259c.186-.031.775,2.528,1.319,5.709s.832,5.793.647,5.826-.775-2.528-1.319-5.709-.832-5.793-.647-5.826",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_196",
    "data-name": "Caminho 196",
    d: "M259.9,721.623c.167.087-1.73,4.077-4.234,8.911s-4.674,8.684-4.836,8.6,1.728-4.076,4.234-8.911,4.673-8.684,4.836-8.6",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_197",
    "data-name": "Caminho 197",
    d: "M243.79,705.543c.169-.085,1.776,2.8,3.589,6.446s3.148,6.667,2.979,6.749-1.776-2.8-3.59-6.446-3.147-6.666-2.978-6.749",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_198",
    "data-name": "Caminho 198",
    d: "M220.121,760.537c-.045.2-2.917-.362-6.5-.608-3.58-.262-6.5-.109-6.519-.315-.022-.175,2.921-.632,6.567-.366s6.5,1.12,6.45,1.289",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_199",
    "data-name": "Caminho 199",
    d: "M236.289,809.157l8.053,42.353a5.935,5.935,0,0,0,5.826,4.826h23.8a5.935,5.935,0,0,0,5.856-4.965l7-42.21Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_200",
    "data-name": "Caminho 200",
    d: "M238.9,822.922h45.5l2.419-13.766H236.289Z",
    fill: "#c1b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_201",
    "data-name": "Caminho 201",
    d: "M238.9,822.922l.954,5.019h43.847l.7-5.019Z",
    fill: "#fafafa"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenImage);
export default __webpack_public_path__ + "static/media/tokenImage.a8528625872a7057aa1e8a454548be31.svg";
export { ForwardRef as ReactComponent };